import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getImgUrl() {
  return Cookies.get('imgUrl') || `${window.location.origin}/`
}

export function setImgUrl(url) {
  return Cookies.set('imgUrl', url)
}

export function setVideoUrl(val) {
  return Cookies.set('videoUrl', val)
}

export function getVideoUrl() {
  const base = Cookies.get('videoUrl') || `${window.location.origin}/`
  return encodeURI(base)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js